var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import bFormGroup from "bootstrap-vue/es/components/form-group/form-group";
import bFormInput from "bootstrap-vue/es/components/form-input/form-input";
import bInputGroup from "bootstrap-vue/es/components/input-group/input-group";
import bFormSelect from "bootstrap-vue/es/components/form-select/form-select";
import bInputGroupAddon from "bootstrap-vue/es/components/input-group/input-group-addon";
import bFormCheckbox from "bootstrap-vue/es/components/form-checkbox/form-checkbox";
import bFormTextArea from "bootstrap-vue/es/components/form-textarea/form-textarea";
import DateRangePicker from "./DateRangePicker.vue";
import Log from "../Directives/Log.ts";
var FormGroup = /** @class */ (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.localValue = _this.value || null;
        _this.localStart = _this.start || null;
        _this.localEnd = _this.end || null;
        return _this;
    }
    FormGroup.prototype.onValueChanged = function (val) { this.localValue = val; };
    FormGroup.prototype.onLocalValueChanged = function (val) { this.$emit("input", val); };
    FormGroup.prototype.onStartChanged = function (val) { this.localStart = val; };
    FormGroup.prototype.onLocalStartChanged = function (val) { this.$emit("update:start", val); };
    FormGroup.prototype.onEndChanged = function (val) { this.localEnd = val; };
    FormGroup.prototype.onLocalEndChanged = function (val) { this.$emit("update:end", val); };
    FormGroup.prototype.onChange = function () {
        if (!this.$v)
            return;
        this.$v.$touch();
    };
    __decorate([
        Prop({ type: Boolean, default: false })
    ], FormGroup.prototype, "stacked", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], FormGroup.prototype, "disabled", void 0);
    __decorate([
        Prop()
    ], FormGroup.prototype, "value", void 0);
    __decorate([
        Watch("value")
    ], FormGroup.prototype, "onValueChanged", null);
    __decorate([
        Watch("localValue")
    ], FormGroup.prototype, "onLocalValueChanged", null);
    __decorate([
        Prop({ type: Object, required: true })
    ], FormGroup.prototype, "metadata", void 0);
    __decorate([
        Prop({ type: Object })
    ], FormGroup.prototype, "$v", void 0);
    __decorate([
        Prop({ type: String, default: "text" })
    ], FormGroup.prototype, "type", void 0);
    __decorate([
        Prop({ type: String })
    ], FormGroup.prototype, "addonClass", void 0);
    __decorate([
        Prop({ type: String, default: "left", validator: function (value) { return value && ["left", "right"].indexOf(value) !== -1; } })
    ], FormGroup.prototype, "addonPosition", void 0);
    __decorate([
        Prop({ type: Number })
    ], FormGroup.prototype, "min", void 0);
    __decorate([
        Prop({ type: Number })
    ], FormGroup.prototype, "max", void 0);
    __decorate([
        Prop({ type: String, default: "input", validator: function (value) { return value && ["input", "label"].indexOf(value) !== -1; } })
    ], FormGroup.prototype, "descriptionPosition", void 0);
    __decorate([
        Prop({ type: String })
    ], FormGroup.prototype, "label", void 0);
    __decorate([
        Prop({ type: Date })
    ], FormGroup.prototype, "start", void 0);
    __decorate([
        Watch("start")
    ], FormGroup.prototype, "onStartChanged", null);
    __decorate([
        Watch("localStart")
    ], FormGroup.prototype, "onLocalStartChanged", null);
    __decorate([
        Prop({ type: String })
    ], FormGroup.prototype, "mStart", void 0);
    __decorate([
        Prop({ type: Date })
    ], FormGroup.prototype, "end", void 0);
    __decorate([
        Watch("end")
    ], FormGroup.prototype, "onEndChanged", null);
    __decorate([
        Watch("localEnd")
    ], FormGroup.prototype, "onLocalEndChanged", null);
    __decorate([
        Prop({ type: String })
    ], FormGroup.prototype, "mEnd", void 0);
    FormGroup = __decorate([
        Component({
            name: "FormGroup",
            components: {
                "form-group": bFormGroup,
                "form-input": bFormInput,
                "input-group": bInputGroup,
                "form-select": bFormSelect,
                "input-group-addon": bInputGroupAddon,
                "form-checkbox": bFormCheckbox,
                "form-text-area": bFormTextArea,
                DateRangePicker: DateRangePicker
            },
            directives: {
                Log: Log
            }
        })
    ], FormGroup);
    return FormGroup;
}(Vue));
export default FormGroup;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/FormGroup.vue
// module id = 671
// module chunks = 24